import { Col, Row, Tag } from "antd";
import FilterMenu from "components/_storybooks/FilterMenu";
import FilterDate from "components/CustomFilterMenu/FilterDate";
import CustomTable from "components/CustomTable";
import CustomDivider from "features/KeyManagement/KeyDetail/CustomDivider";
import { t } from "i18next";
import { formatDateTime } from "utils/dateTime";
import { formatNumberVN } from "utils/helperFuncs";
import { FiltersTag } from "./filter-tag";
import { useTable } from "./useTable";
import { Link } from "react-router-dom";

export const TableLoyaltyTransaction = () => {
  const {
    loyaltyTransactions,
    paginationData,
    loading,
    params,
    handleChangeFilter,
    handleChangeTable,
    handleChangeDate,
    handleRemoveFilterTag,
  } = useTable();

  const actionMap = {
    LOYALTY_PACKAGE_AWARD: "Nhận HAP theo CK gói",
    ORDER_PAYMENT: "Sử dụng HAP",
    ORDER_REFUND: "Hoàn HAP",
    AWARD: "Nhận HAP",
    EXPIRATION: "Hết hạn sử dụng HAP",
  };

  const actionMapOptions = [
    { value: "LOYALTY_PACKAGE_AWARD", label: "Nhận HAP theo CK gói" },
    { value: "ORDER_PAYMENT", label: "Sử dụng HAP" },
    { value: "ORDER_REFUND", label: "Hoàn HAP" },
    { value: "AWARD", label: "Nhận HAP" },
    { value: "EXPIRATION", label: "Hết hạn sử dụng HAP" },
  ];

  const columns = [
    {
      title: <span className="title-column">STT</span>,
      align: "center",
      width: 50,
      render: (_, record, index) => {
        return index + 1;
      },
    },
    {
      title: <span className="title-column">{t("seller.activitylogtabs.table.dateUpdate")}</span>,
      align: "center",
      width: 120,
      dataIndex: "updatedAt",
      render: (_, record, index) => {
        return formatDateTime(record?.createdAt);
      },
      sorter: true,
    },
    {
      title: <span className="title-column">HÀNH ĐỘNG</span>,
      align: "center",
      dataIndex: "action",
      render: (_, record, index) => {
        return actionMap[record?.type] || "- -";
      },
      filterDropdown: (
        <FilterMenu
          onFilter={(value) => handleChangeFilter("transactionTypes", value)}
          type="checkbox"
          searchable
          options={actionMapOptions}
        />
      ),
    },
    {
      title: <span className="title-column">CHI TIẾT/ LÝ DO</span>,
      align: "left",
      render: (_, record) => {
        const desc = record?.desc || "- -";
        const orderCodeRegex = /(DH\d{17})/g;

        if (record?.order && orderCodeRegex.test(desc)) {
          const parts = desc.split(orderCodeRegex);

          return (
            <span>
              {parts.map((part, index) => {
                if (orderCodeRegex.test(part)) {
                  return (
                    <Link
                      key={index}
                      to={`/order/${record.order.id}`}
                      style={{ color: "#1953D8", fontWeight: 600 }}
                      target="_blank"
                    >
                      {record.order.number}
                    </Link>
                  );
                }
                return <span key={index}>{part}</span>;
              })}
            </span>
          );
        }

        return desc;
      },
    },
    {
      title: <span className="title-column">GIAO DỊCH HAP</span>,
      align: "right",
      dataIndex: "updatedBy",
      render: (_, record) => {
        return (
          <Tag color={record?.point > 0 ? "green" : "orange"}>
            {`${record?.point > 0 ? "+" : ""}${formatNumberVN(record?.point || 0)} HAP`}
          </Tag>
        );
      },
    },
  ];

  return (
    <div style={{ marginTop: "24px" }}>
      <CustomDivider title={"Theo dõi giao dịch HAP"} />
      <Row gutter={[24, 4]} style={{ marginTop: "12px" }}>
        <Col span={24}>
          <div style={{ width: "150px" }}>
            <FilterDate title={"Thời gian"} onChangeDate={handleChangeDate} />
            <FiltersTag
              transactionTypesFilter={params?.filters?.transactionTypes || []}
              rangeDateTimeFilter={params?.filters?.timeFilter || []}
              actionMapOptions={actionMapOptions}
              handleRemoveFilterTag={handleRemoveFilterTag}
            />
          </div>
        </Col>
        <Col span={24}>
          <CustomTable
            columns={columns}
            dataSource={loyaltyTransactions ?? []}
            loading={loading}
            onChange={handleChangeTable}
            pagination={{
              total: paginationData?.total ?? 0,
              pageSize: paginationData?.limit,
              current: paginationData?.offset / paginationData?.limit + 1 || 1,
              showSizeChanger: false,
            }}
          />
        </Col>
      </Row>
    </div>
  );
};
